export const geografie = [
  "China",
  "Mexico",
  "Indonesië",
  "Brazilië",
  "Pakistan",
  "Nigeria",
  "Rusland",
  "Japan",
  "Ethiopië",
  "Egypte",
  "Congo-Kinshasa",
  "Bangladesh",
  "Colombia",
  "Filipijnen",
  "Vietnam",
  "Turkije",
  "Iran",
  "Duitsland",
  "Thailand",
  "Verenigd Koninkrijk",
  "Frankrijk",
  "Italië",
  "Tanzania",
  "Zuid-Afrika",
  "Myanmar (Birma)",
  "Kenia",
  "Zuid-Korea",
  "Spanje",
  "Argentinië",
  "Oekraïne",
  "Soedan",
  "Oeganda",
  "Algerije",
  "Irak",
  "Polen",
  "Canada",
  "Marokko",
  "Saudi-Arabië",
  "Oezbekistan",
  "Peru",
  "Angola",
  "Maleisië",
  "Mozambique",
  "Ghana",
  "Jemen",
  "Nepal",
  "Venezuela",
  "Madagaskar",
  "Ivoorkust",
  "Australië",
  "Noord-Korea",
  "Niger",
  "Sri Lanka",
  "Burkina Faso",
  "Mali",
  "Roemenië",
  "Malawi",
  "Chili",
  "Kazachstan",
  "Zambia",
  "Syrië",
  "Ecuador",
  "Nederland",
  "Guatemala",
  "Senegal",
  "Tsjaad",
  "Somalië",
  "Cambodja",
  "Zimbabwe",
  "Zuid-Soedan",
  "Rwanda",
  "Tunesië",
  "België",
  "Cuba",
  "Bolivia",
  "Haïti",
  "Griekenland",
  "Benin",
  "Tsjechië",
  "Portugal",
  "Burundi",
  "Honduras",
  "Zwitserland",
  "Dominicaanse Republiek",
  "Zweden",
  "Guinee",
  "Azerbeidzjan",
  "Hongarije",
  "Wit-Rusland",
  "Tadzjikistan",
  "Servië",
  "Oostenrijk",
  "Verenigde Arabische Emiraten",
  "Israël",
  "Papoea-Nieuw-Guinea",
  "Libië",
  "Sierra Leone",
  "Hongkong",
  "Laos",
  "Paraguay",
  "Bulgarije",
  "Libanon",
  "Nicaragua",
  "El Salvador",
  "Kyrgyzstan",
  "Amsterdam",
  "Parijs",
  "Londen",
  "New York",
  "Tokio",
  "Istanboel",
  "Mumbai",
  "Kairo",
  "Rio de Janeiro",
  "Sydney",
  "Kaapstad",
  "Sint-Petersburg",
  "Dubai",
  "Los Angeles",
  "Toronto",
  "Berlijn",
  "Hongkong",
  "Rome",
  "Milaan",
  "Wenen",
  "San Francisco",
  "Seoul",
  "München",
  "Moskou",
  "Barcelona",
  "Madrid",
  "Chicago",
  "Shanghai",
  "Mexico-Stad",
  "Kaïro",
  "Boedapest",
  "Delhi",
  "Bangkok",
  "Beiroet",
  "Kopenhagen",
  "Helsinki",
  "Oslo",
  "Zürich",
  "Stockholm",
  "Jakarta",
  "Kaohsiung",
  "Lima",
  "Manila",
  "Auckland",
  "Montreal",
  "Amman",
  "Boekarest",
  "Nairobi",
  "Wenen",
  "Dublin",
  "Brussel",
  "Warschau",
  "Prague",
  "Marrakech",
  "Beijing",
  "Casablanca",
  "Tehran",
  "Athene",
  "Porto",
  "Hamburg",
  "Frankfurt",
  "Hanoi",
  "Osaka",
  "Ho Chi Minh-stad",
  "Rio de Janeiro",
  "Riodejaneiro",
  "Mumbai",
  "Istanbul",
  "Wenen",
  "Warschau",
  "Buenos Aires",
  "Lima",
  "Rome",
  "Praag",
  "Kopenhagen",
  "Athene",
  "Lissabon",
  "Dublin",
  "Boedapest",
  "Kiev",
  "Madrid",
  "Milaan",
  "Venetië",
  "Napels",
  "Genève",
  "Stockholm",
  "Helsinki",
  "Oslo",
  "Kopenhagen",
  "Zürich",
  "Brussel",
  "Amsterdam",
  "Hamburg",
  "Berlijn",
  "München",
  "Parijs",
  "Lyon",
  "Marseille",
  "Nice",
  "Barcelona",
  "Valencia",
  "Madrid",
  "Lissabon",
  "Porto",
  "Londen",
  "Manchester",
  "Birmingham",
  "Edinburgh",
  "Glasgow",
  "Dublin",
  "Belfast",
  "Continent",
  "Land",
  "Stad",
  "Hoofdstad",
  "Rivier",
  "Berg",
  "Eiland",
  "Zee",
  "Oceaan",
  "Golf",
  "Baai",
  "Delta",
  "Kanaal",
  "Meer",
  "Vulkaan",
  "Woestijn",
  "Regenwoud",
  "Gletsjer",
  "Schiereiland",
  "Kaap",
  "Straat",
  "Kloof",
  "Grot",
  "Atol",
  "Koraalrif",
  "Krater",
  "Lagune",
  "Moeras",
  "Steppe",
  "Plateau",
  "Vallei",
  "Canyon",
  "Vlakte",
  "Zeestraat",
  "Zandduin",
  "Kust",
  "Archipel",
  "Baai",
  "Fjord",
  "Inham",
  "Schiereiland",
  "Zandbank",
  "Savanne",
  "Estuarium",
  "Delta",
  "Polder",
  "Waddenzee",
  "Binnenland",
  "Kustlijn",
  "Stroomgebied",
  "Hoogland",
];
